import { css } from '@emotion/react';

import { styled } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';
import { Button } from '../../../../buttons';

export const DownloadAttachButton = styled(Button)(
	({ theme }: { theme: Theme }) => theme.allSettings.attachments.downloadAttachButton,
	css`
		display: inline-block;
	`
);
